import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const items = ['Vuoi mangiare meglio ma non hai tempo di passare ore in cucina', 'Ti senti spesso stanco, gonfio o senza energia durante il giorno', 'Sei stanco delle diete che promettono tutto e non mantengono nulla', 'Ami il cibo e non hai nessuna intenzione di smettere di gustartelo', 'Cerchi un approccio realistico e sostenibile nel tempo'];
export function ForYouChecklist() {
  return <section className="py-12 px-4 bg-brand-warm" data-id="element-130">
      <div className="max-w-xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-132">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text-main mb-3" data-id="element-133">
            Questo sistema è stato creato per te se:
          </h2>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-134">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex gap-3 items-start bg-white p-4 rounded-xl border border-brand-sage/20 shadow-sm" data-id="element-135">
              <div className="mt-0.5 bg-brand-olive/10 p-1 rounded-full shrink-0" data-id="element-136">
                <CheckIcon className="w-5 h-5 text-brand-olive" strokeWidth={3} data-id="element-137" />
              </div>
              <p className="text-brand-text-main font-medium leading-snug" data-id="element-138">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}